import React, {Component} from 'react'
import CustomersApiService from '../../api-services/CustomersApiService'
import APIServicesRegistry from '../../api-services/APIServicesRegistry'
import Modal from '../common/Modal';
import ProjectStore from '../../store/projectStore'
import {observer} from 'mobx-react';
import ModalIndexPage from '../index-table/ModalIndexPage';
import Button from '../common/Button';
import Loader from '../common/Loader';
import TWSCustomerApiService from "@lib/api-services/TWSCustomerApiService";
import TWSCustomersApiService from "@lib/api-services/TWSCustomersApiService";

const ChooseCustomerModal = observer(
    class ChooseCustomerModal extends Component {


        state = {
            index: null,
            selected: {},
            rootCheckboxSelected: false,
            loading: false,
            adding: false
        }

        componentDidMount() {
            scheduleAtDocumentReady(() => {
                if (this.props.twsCustomer) {
                    this.customersApiService = APIServicesRegistry.getService(TWSCustomersApiService);
                } else {
                    this.customersApiService = APIServicesRegistry.getService(CustomersApiService);
                }

                this.initConfigurations();
            });
        }

        multiSelectRows = () => {

            return false;

        };

        initConfigurations() {

            this.customersApiService.indexExternal().then(result => {
                this.setState({
                    index: result.data
                });
            });
        }

        onModelCloseRequest = () => {
            ProjectStore.setAddExistingConfigurationModalVisible(false);
        }

        onRowCheckedClick = (selectedRow) => {

            this.setState({selected: selectedRow});
        }

        onRootCheckboxClick() {

        }

        onCancelClik = () => {
            ProjectStore.setChooseCustomerModalVisible(false);
        }

        onAddConfigurationsClick = () => {
            let customer = this.state.selected[0] || {};

            if (customer.id != undefined) {
                ProjectStore.formModel.generalInformation.customerFullName.value = customer.name;
                ProjectStore.formModel.generalInformation.customerCompany.value = customer.company;
                ProjectStore.formModel.generalInformation.customerAddress.value = customer.address;
                ProjectStore.formModel.generalInformation.customerCountry.value = customer.country;
                ProjectStore.formModel.generalInformation.customerCountry.value = customer.country;
                ProjectStore.formModel.generalInformation.customerId.value = customer.id;
                ProjectStore.setDirty(true);
            }
            this.onCancelClik();


        }

        renderModalBody() {
            const {columns, filter, paging, options} = this.state.index;
            let results = this.state.index.results;


            return (
                <ModalIndexPage
                    columns={columns}
                    filter={filter}
                    results={results}
                    paging={paging}
                    options={options}
                    onRowCheckboxToggled={this.onRowCheckedClick}
                    onRootCheckboxToggled={this.onRootCheckboxClick}
                    multiSelectRows={this.multiSelectRows}
                    indexApiService={this.props.twsCustomer ? TWSCustomersApiService : CustomersApiService}
                    renderActionButtons={this.renderActionButtons}
                />
            )
        }


        renderLoader() {
            return (
                <Loader fillContainer={true}/>
            )
        }

        renderActionButtons = () => (
            this.state.index && (
                <div className="index-modal-button-actions">
                    <Button onClick={this.onCancelClik}>{__('Cancel')}</Button>
                    <Button disabled={this.state.adding}
                            onClick={this.onAddConfigurationsClick}>{__(this.state.adding ? 'Adding...' : 'Add')}</Button>
                </div>
            )
        )

        render() {
            return (
                <Modal isOpen={ProjectStore.chooseCustomerModalVisible} onClose={this.onModelCloseRequest} width="auto">
                    <Modal.Header>{__('Customers')}</Modal.Header>
                    <Modal.Body>
                        <div style={{position: 'relative'}}>
                            {this.state.index ? (
                                this.renderModalBody()
                            ) : (
                                this.renderLoader()
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            )
        }

    }
)


export default ChooseCustomerModal